import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import uploadingStatuses from 'shared/constants/uploading-statuses';

import { normalizeArrayOfVideos } from 'shared/redux/helpers/normalized';

import { toFakeVideoData } from 'dashboard/redux/helpers/upload';


const ACTIONS = createAsyncActions('SERVER.VIDEOS.CREATE', ['START', 'ITEM_CREATED', 'SUCCESS', 'FAIL']);
export const NAMES = ACTIONS.NAMES;
const { START, ITEM_CREATED, SUCCESS, FAIL } = ACTIONS;

export { SUCCESS };


export default function (videoDataList, meta) {
  return function (dispatch, getState) {
    const { vodSettings } = getState();
    const { defaultChannelId } = vodSettings;

    const fakeVideoDataList = _.map(videoDataList, videoData => ({
      ...toFakeVideoData(),
      ...videoData,
    }));

    dispatch(START(fakeVideoDataList, { data: normalizeArrayOfVideos(fakeVideoDataList) }, meta));

    const createPromise = vodAdapter.items.createInList(videoDataList, defaultChannelId);

    createPromise.on(vodAdapter.events.ITEMS.CREATE.SUCCESS, function (response) {
      const data = _.map(response.data, (data, i) => ({
        ...fakeVideoDataList[i],
        ...data,
        uploadingStatus: uploadingStatuses.SUCCEEDED,
      }));

      response = { ...response, data: normalizeArrayOfVideos(data) };
      dispatch(ITEM_CREATED(fakeVideoDataList, response, meta));
    });

    return createPromise
      .then(
        function (response) {
          const data = _.map(response.data, data => ({
            ...data,
            uploadingStatus: uploadingStatuses.SUCCEEDED,
          }));

          response = { ...response, data: normalizeArrayOfVideos(data) };

          dispatch(SUCCESS(fakeVideoDataList, response, meta));
          return response;
        },

        function (error) {
          dispatch(FAIL(fakeVideoDataList, error, {
            ...meta,
            analytics: [
              { type: 'error', name: 'dashboard.video.create' },
              {
                type: 'detailed-error',
                payload: { name: 'upload-error', errorData: error },
              },
            ],
          }));
          return error;
        }
      );

  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/videos/create.js